import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, Divider, Flex, Popover, PopoverBody, PopoverContent, PopoverHeader, PopoverTrigger, Text } from '@chakra-ui/react';
import React from 'react';
import { styles } from './user-profile.styles';
import './user-profile.scss';
import { useSelector } from 'react-redux';
import { MyStatus } from '../../views/time-entry/my-status';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
export const UserProfile = (props)=>{
    const { userInitials, onLogout, openAccountSettings, openCapturedTime, listStatus, updateStatus, profile_src, activeUser } = props;
    const classes = styles();
    const ui = useSelector((state)=>state.ui);
    const resources = ui.context.activeContext?.resources ?? [];
    const timeEntryResource = new Set([
        'protected_time'
    ]);
    const timeEntry = resources.some((resource)=>timeEntryResource.has(resource.resourceName));
    return /*#__PURE__*/ _jsxs(PopoverContent, {
        sx: {
            ...classes['.mainGrid'],
            _focus: {
                boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                outline: 'none'
            },
            _focusVisible: {
                boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                outline: 'none'
            }
        },
        className: "popOverStyle",
        children: [
            /*#__PURE__*/ _jsxs(PopoverHeader, {
                sx: classes['.headerGrid'],
                children: [
                    /*#__PURE__*/ _jsxs(Flex, {
                        sx: classes['.headerFlex'],
                        children: [
                            /*#__PURE__*/ _jsx(Avatar, {
                                name: userInitials,
                                src: profile_src,
                                sx: classes['.usernNameAvatar']
                            }),
                            /*#__PURE__*/ _jsxs(Flex, {
                                sx: classes['.userHeader'],
                                children: [
                                    /*#__PURE__*/ _jsx(Flex, {
                                        sx: classes['.userName'],
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            className: "text",
                                            children: `${activeUser?.firstName} ${activeUser?.lastName}`
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Flex, {
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            sx: classes['.userNameText'],
                                            children: activeUser?.username
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Divider, {
                        sx: classes['.divider']
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(PopoverBody, {
                children: [
                    timeEntry && /*#__PURE__*/ _jsx(_Fragment, {
                        children: /*#__PURE__*/ _jsxs(Popover, {
                            id: "my-status-popover",
                            closeOnBlur: true,
                            placement: "right",
                            trigger: "hover",
                            children: [
                                /*#__PURE__*/ _jsx(PopoverTrigger, {
                                    children: /*#__PURE__*/ _jsxs(Flex, {
                                        sx: classes['.switchItem'],
                                        className: `hoverCursor`,
                                        "data-testid": 'availabilityTracker',
                                        children: [
                                            /*#__PURE__*/ _jsx(BiomeIcon, {
                                                iconName: IconName.Calendar,
                                                titleText: "Date"
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                className: "text",
                                                sx: classes['.textStyles'],
                                                children: "My Status"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(MyStatus, {
                                    listStatus: listStatus,
                                    updateStatus: updateStatus,
                                    user: ui.activeUser,
                                    context: ui.context
                                })
                            ]
                        })
                    }),
                    timeEntry && /*#__PURE__*/ _jsxs(Flex, {
                        sx: classes['.switchItem'],
                        className: `hoverCursor`,
                        "data-testid": 'normalTime',
                        onClick: openCapturedTime,
                        children: [
                            /*#__PURE__*/ _jsx(BiomeIcon, {
                                iconName: IconName.Calendar,
                                titleText: "Date"
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                className: "text",
                                sx: classes['.textStyles'],
                                children: "Captured Time"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        sx: classes['.switchItem'],
                        className: `hoverCursor`,
                        "data-testid": 'accountSettings',
                        onClick: openAccountSettings,
                        children: [
                            /*#__PURE__*/ _jsx(BiomeIcon, {
                                iconName: IconName.Settings,
                                titleText: "Settings"
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                className: "text",
                                sx: classes['.textStyles'],
                                children: "Account Settings"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        sx: classes['.switchItem'],
                        className: `hoverCursor`,
                        "data-testid": 'logOut',
                        onClick: onLogout,
                        children: [
                            /*#__PURE__*/ _jsx(BiomeIcon, {
                                iconName: IconName.Logout,
                                titleText: "Logout"
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                className: "text",
                                sx: classes['.textStyles'],
                                children: "Log out"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
